import React, { useState, useEffect } from 'react';
import { TextField, Checkbox, ListItemText } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Label from '../../components/label';

const MultiSelectCheckboxAutocomplete = ({ tags, setValues, selectedTags }) => {
    const [seleTags, setTags] = useState([]);

    useEffect(() => {
        setTags(selectedTags || []);
    }, [selectedTags]);

    return (
        <>
            <Autocomplete
                multiple
                options={tags}
                disableCloseOnSelect
                limitTags={1}
                getOptionLabel={(option) => option}
                getOptionSelected={(option, value) => option === value}
                value={seleTags}
                onChange={(event, newValue) => {
                    setTags(newValue);
                    setValues(newValue);
                }}
                renderOption={(option, { selected }) => (
                    <>
                        <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                            color="primary"
                        />
                        <ListItemText primary={option} />
                    </>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Topics"
                        placeholder="Choose..."
                    />
                )}
                className="w-100 mx-auto"
            />
        </>
    );
};

export default MultiSelectCheckboxAutocomplete;
